import { createContext, Dispatch } from 'react';

type initialStateType = {
  _id: string,
  createModalReports: boolean,
  findModalReports: boolean,
  deleteModalReports: boolean,
  createModalGraph: boolean,
  report: any
  editModalReports: boolean,
  previewData: any,
  reportPreviewData:any
}

type ModalPartial = {
  state: initialStateType,
  dispatch: Dispatch<any>
}

export const initialState = {
  _id: '',
  createModalReports: false,
  findModalReports: false,
  editModalReports: false,
  deleteModalReports: false,
  createModalGraph: false,  
  previewData: null,
  report: null,
  reportPreviewData:null  
}
export enum Types {
  CREATE_REPORTS = "CREATE_REPORTS",
  EDIT_REPORTS = "EDIT_REPORTS",
  CLEAR_REPORTS = "CLEAR_REPORTS",
  DELETE_REPORTS = "DELETE_REPORTS",
  FIND_DATE_REPORTS = "FIND_DATE_CAMPAIGNS",
  CLOSE_CREATE_REPORTS = "CLOSE_CREATE_REPORTS",
  PREVIEW_DATA = "PREVIEW_DATA",
  LOAD_DATA_REPORT = "LOAD_DATA_REPORT",
  CREATE_GRAPH = 'CREATE_GRAPH',
  UPDATE_VISIBLE_COLUMNS= "UPDATE_VISIBLE_COLUMNS",
  UPDATE_SELECTED_GROUP="UPDATE_SELECTED_GROUP",
  INPUT_VALUES="INPUT_VALUES",
  UPDATE_REPORT_DATA="UPDATE_REPORT_DATA", 
}

const ModalInitialState = {
  state: initialState,
  dispatch: () => null
}

const ReportContext = createContext<ModalPartial>(ModalInitialState)

export default ReportContext; 
